import React from "react";
import { t } from "@lingui/macro";
import { ViewDetailsList, StringToHTML, i18n, cleanHtml } from "idc-ui-react";

const GroupsList = ({ rolegroups }) => {
  const columns = [
    {
      key: "name",
      name: i18n._(t`Name`),
      fieldName: "name",
      minWidth: 100,
      maxWidth: 200,
      applyColumnFilter: true,
      applyColumnClick: true,
      isSorted: true,
      isSortedDescending: false
    },
    {
      key: "description",
      name: i18n._(t`Description`),
      fieldName: "description",
      minWidth: 300,
      maxWidth: 900,
      isMultiline: true,
      applyColumnDisabled: true,
      onRender: ({ description }) => {
        if (description && description.length > 200)
          return (
            <StringToHTML
              text={description.substring(0, 200) + "..."}
            ></StringToHTML>
          );
        return <StringToHTML text={cleanHtml(description)}></StringToHTML>;
      }
    }
  ];

  return <ViewDetailsList items={rolegroups} columns={columns} />;
};

export default GroupsList;
